<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_139_2)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.12658 12C2.12658 6.54706 6.54706 2.12658 12 2.12658C17.4529 2.12658 21.8734 6.54706 21.8734 12C21.8734 17.4529 17.4529 21.8734 12 21.8734C6.54706 21.8734 2.12658 17.4529 2.12658 12ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM13.0633 5.92405C13.0633 5.33682 12.5872 4.86076 12 4.86076C11.4128 4.86076 10.9367 5.33682 10.9367 5.92405V12C10.9367 12.282 11.0487 12.5525 11.2481 12.7519L14.8937 16.3974C15.3089 16.8127 15.9822 16.8127 16.3974 16.3974C16.8127 15.9822 16.8127 15.309 16.3974 14.8937L13.0633 11.5596V5.92405Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_139_2">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
